import { Dates } from '@app/constants/Dates';
import { LanguageType } from '@app/interfaces/interfaces';
import { useCallback, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const defaultLanguage = process.env.REACT_APP_LANGUAGE;
const localLanguage = (sessionStorage.getItem('vi') as LanguageType) ?? defaultLanguage;
export const useLanguage = (): { language: LanguageType; setLanguage: (locale: LanguageType) => Promise<void> } => {
  const { i18n } = useTranslation();
  const handleChangeLanguage = useCallback(
    async (locale: LanguageType) => {
      Dates.setLocale('en');
      sessionStorage.setItem('vi', locale);
      await i18n.changeLanguage(locale);
    },
    [i18n],
  );

  useEffect(() => {
    localLanguage && handleChangeLanguage(localLanguage);
  }, [handleChangeLanguage]);

  return useMemo(
    () => ({ language: i18n.language as LanguageType, setLanguage: handleChangeLanguage }),
    [handleChangeLanguage, i18n.language],
  );
};
